<template>
  <router-link to="/">
  <div layout="column top-center" class="w100">

    <div :class="{container:!isIE, 'container-ie':isIE}">
      <div layout="row center-center">
        <img class="background-image" src="/static/images/header-back.png" srcset="/static/images/header-back@2x.png 2x"/>
      </div>
      <div class="elements-container w100" layout="row center-spread">
        <div>
          <img class="car-image" src="/static/images/car-icon.png" srcset="/static/images/car-icon@2x.png 2x"/>
        </div>

        <div>
          <img class="claim-image" src="/static/images/claim.png" srcset="/static/images/claim@2x.png"/>
        </div>

        <div self="top">
          <img class="smart-image" src="/static/images/smart-logo.png" srcset="/static/images/smart-logo@2x.png 2x"/>
        </div>
      </div>
    </div>

  </div>
  </router-link>
</template>

<script>
  import detect from 'detect-browser';

  export default {
    name: "smart-header",
    data() {
      return {
        isIE: detect.detect().name == 'ie'
      }
    }
  }
</script>

<style lang="scss" scoped>

  .container-ie {
    position: relative;
    z-index: 10;
    width: 100%;
    top: 0;
    max-width: 1400px;
    overflow: hidden;
  }

  .container {
    position: fixed;
    z-index: 10;
    width: 100%;
    top: 0;
    max-width: 1400px;
    overflow: hidden;
  }

  $min-width: 800px;

  .background-image {
    width: 100%;
    height: 10vw;
    max-height: 130px;
    min-height: 80px;

    max-width: 1400px;
    min-width: 600px;
  }

  .car-image {
    height: 8vw;
    max-height: 80px;
    min-height: 70px;
    @media screen and (max-width: $min-width) {
      display: none;
    }
  }

  .claim-image {
    height: 4vw;
    max-height: 90px;
    min-height: 40px;
    margin-left: -2vw;
  }

  .smart-image {
    height: 7.5vw;
    max-height: 100px;
    min-height: 60px;
    @media screen and (max-width: $min-width) {
      margin-left: 10px;
    }
  }

  .elements-container {
    position: absolute;
    top: 0;
    left: 0;
    height: 10vw;
    max-height: 130px;
    min-height: 80px;
  }


</style>



// WEBPACK FOOTER //
// src/components/SmartHeader.vue